import { Settings, Calendar, DollarSign } from 'lucide-react';
import courseProfileImage from 'figma:asset/504d75bcacd61b8a52d2ad3050008f7a5e96092a.png';
import bookingsManagementImage from 'figma:asset/1b2502ff80acd6f19cd8b8007501841531239858.png';
import paymentsImage from 'figma:asset/d609e4098f034abf28f69dcfbee012c50d151db5.png';

export function HowItWorksOwners() {
  const steps = [
    {
      icon: Settings,
      title: 'set your course details',
      description: 'add photos, descriptions, booking rules, and pricing for your private course',
      image: courseProfileImage
    },
    {
      icon: Calendar,
      title: 'manage bookings',
      description: 'track and manage all player bookings with weekly schedule overview and availability controls',
      image: bookingsManagementImage
    },
    {
      icon: DollarSign,
      title: 'get paid securely',
      description: 'receive payments automatically with detailed earnings tracking and payouts',
      image: paymentsImage
    }
  ];

  return (
    <section id="owners" className="py-16 lg:py-24 bg-accent/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-foreground lowercase mb-4">
            how it works for <span className="text-primary">course owners</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            monetize your private course and manage bookings with our comprehensive dashboard
          </p>
        </div>

        <div className="space-y-16">
          {steps.map((step, index) => {
            const Icon = step.icon;
            const isEven = index % 2 === 0;
            
            return (
              <div
                key={index}
                className={`grid lg:grid-cols-2 gap-8 lg:gap-12 items-center ${
                  isEven ? '' : 'lg:grid-flow-col-dense'
                }`}
              >
                {/* Content */}
                <div className={`space-y-6 ${isEven ? '' : 'lg:col-start-2'}`}>
                  <div className="flex items-center space-x-4">
                    <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center">
                      <Icon className="w-6 h-6 text-primary" />
                    </div>
                    <span className="text-sm font-medium text-primary uppercase tracking-wide">
                      step {index + 1}
                    </span>
                  </div>
                  
                  <div className="space-y-4">
                    <h3 className="text-2xl sm:text-3xl font-bold text-foreground lowercase">
                      {step.title}
                    </h3>
                    <p className="text-lg text-muted-foreground">
                      {step.description}
                    </p>
                  </div>
                </div>

                {/* Dashboard Screenshot */}
                <div className={`${isEven ? '' : 'lg:col-start-1'}`}>
                  <div className="relative group">
                    <div className="bg-white rounded-2xl shadow-2xl overflow-hidden transform hover:scale-105 transition-transform duration-300">
                      <img
                        src={step.image}
                        alt={`Discgo ${step.title} dashboard`}
                        className="w-full h-auto"
                      />
                    </div>
                    
                    {/* Background Glow */}
                    <div className="absolute inset-0 -z-10 bg-primary/5 rounded-2xl transform scale-110 blur-2xl" />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}